var button = jQuery('.load-more');
var page = 2;
var loading = false;
var hasMorePosts = true;
var queryObject = {
    "post_type": button.attr("data-post-type").split("|"),
    "posts_per_page": button.attr("data-per-page"),
    "category": button.attr("data-category"),
    "template": button.attr("data-template"),
    "taxonomy": button.attr("data-taxonomy"),
    "tax_terms": button.attr("data-tax-terms"),
    "offset": button.attr("data-offset"),
}

jQuery(document).on('click', '.load-more', function(){
    if( ! loading && hasMorePosts) {
        loading = true;
        var data = {
            action: 'kd_ajax_load_more',
            page: page,
            query: queryObject,
        };

        console.log('Loading more...', data);

        jQuery.post('/wp-admin/admin-ajax.php', data, function(res) {

            console.log('Load More Post', data, res);

            // jQuery('.feed .sk-circle').removeClass('show');
            if( res.success) {
                jQuery('.post-listing').append( res.data.html );
                page = page + 1;
                loading = false;
                if ( !res.data.hasMorePosts) {
                    hasMorePosts = false;
                    button.hide()
                }
            } else {

            }
        }).fail(function(xhr, textStatus, e) {
            console.log('Load More Fail', xhr, textStatus);
            // jQuery('.feed .sk-circle').removeClass('show');
        });
    }
});

// jQuery(document).on('change', '.filters', function() {
//     hasMorePosts = true;
//     console.log(jQuery(this).val());
//     jQuery('.filter-wrapper .sk-circle').addClass('show');
//     if(jQuery(this).val() == "*") {
//         queryObject.category = 'all';
//     } else {
//         queryObject.category = jQuery(this).val();
//     }

//     page = 1;
//     queryObject.offset = 0;

//     if( ! loading ) {
//         loading = true;
//         var data = {
//             action: 'kd_ajax_load_more',
//             page: page,
//             query: queryObject,
//         };
//         jQuery.post('/wp-admin/admin-ajax.php', data, function(res) {
//             jQuery('.filter-wrapper .sk-circle').removeClass('show');
//             if( res.success) {
//                 jQuery('.filter-wrapper .sk-circle').removeClass('show');
//                 jQuery('.post-listing').html( res.data.html );
//                 //jQuery('.post-listing').append( button );
//                 page = page + 1;
//                 loading = false;
//                 button.show();
//                 if ( !res.data.hasMorePosts) {
//                     hasMorePosts = false;
//                     button.hide();
//                 }
//             } else {

//             }
//         }).fail(function(xhr, textStatus, e) {
//             jQuery('.filter-wrapper .sk-circle').removeClass('show');
//         });
//     }
// });

jQuery(document).on('change', '.tax-filters', function() {
    hasMorePosts = true;
    console.log('tax-filters change: ', jQuery(this).val());
    // jQuery('.filter-wrapper .tax-filter .sk-circle').addClass('show');

    if(jQuery(this).val() == "*") {
        queryObject.tax_terms = 'all';
    } else {
        queryObject.tax_terms = jQuery(this).val();
    }

    page = 1;
    queryObject.offset = 0;

    if( ! loading ) {
        loading = true;
        var data = {
            action: 'kd_ajax_load_more',
            page: page,
            query: queryObject,
        };

        console.log('tax-filters loading: ', data);

        jQuery.post('/wp-admin/admin-ajax.php', data, function(res) {
            if( res.success) {
                jQuery('.post-listing').html( res.data.html );
                page = page + 1;
                loading = false;
                button.show();
                if ( !res.data.hasMorePosts) {
                    hasMorePosts = false;
                    button.hide();
                }
            } else {

            }
        }).fail(function(xhr, textStatus, e) {
            // jQuery('.filter-wrapper .tax-filter .sk-circle').removeClass('show');
        });
    }
});

// jQuery(document).on('change', '.post-filters', function() {
//     hasMorePosts = true;
//     console.log(jQuery(this).val());
//     jQuery('.post-filter .sk-circle').addClass('show');
//     if(jQuery(this).val() == "*") {
//         queryObject.post_type = ['case_study'];
//     } else {
//         queryObject.post_type = jQuery(this).val();
//     }

//     page = 1;
//     queryObject.offset = 0;

//     if( ! loading ) {
//         loading = true;
//         var data = {
//             action: 'kd_ajax_load_more',
//             page: page,
//             query: queryObject,
//         };
//         jQuery.post('/wp-admin/admin-ajax.php', data, function(res) {
//             jQuery('.post-filter .sk-circle').removeClass('show');
//             if( res.success) {
//                 jQuery('.post-filter .sk-circle').removeClass('show');
//                 jQuery('.post-listing').html( res.data.html );
//                 //jQuery('.post-listing').append( button );
//                 page = page + 1;
//                 loading = false;
//                 button.show();
//                 if ( !res.data.hasMorePosts) {
//                     hasMorePosts = false;
//                     button.hide();
//                 }
//             } else {

//             }
//         }).fail(function(xhr, textStatus, e) {
//             jQuery('.post-filter .sk-circle').removeClass('show');
//         });
//     }
// });
